import type { SVGAttributes } from "react"

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      height="32"
      viewBox="0 0 283 278"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="currentColor"
        transform="translate(0,278) scale(0.1,-0.1)"
      >
        <path d="M887 2742 l18 -29 364 -536 365 -536 4 3 3 4 60 257 59 256 0 9 0 9 -440 295 -440 296 -6 0 -6 0 19 -28z" />
        <path d="M1931 2045 l-174 -696 5 -5 5 -5 217 102 216 102 0 21 1 21 -43 578 -43 577 -5 0 -5 0 -174 -695z" />
        <path d="M498 1818 l-428 -342 4 -3 4 -4 604 166 603 166 13 4 13 5 -191 175 -190 175 -3 0 -2 0 -427 -342z" />
        <path d="M832 1451 l-203 -128 -11 -11 -10 -10 117 -573 117 -574 4 -4 4 -4 0 14 1 14 97 703 98 702 -5 0 -6 -1 -203 -128z" />
        <path d="M2130 1231 l-625 -188 4 -9 4 -9 189 -164 189 -163 17 14 17 15 415 338 415 338 10 9 9 8 -9 -1 -10 0 -625 -188z" />
        <path d="M1195 1038 l-6 -43 -24 -220 -25 -220 18 -13 17 -13 275 -141 275 -141 195 -100 195 -101 -15 19 -15 19 -438 498 -438 498 -4 0 -4 0 -6 -42z" />
      </g>
    </svg>
  )
}
